import React, { useState, useEffect } from "react";
import ApiClient from "../../../methods/api/apiClient";
import loader from "../../../methods/loader";
import { useSelector } from "react-redux";
import methodModel from "../../../methods/methods";
import { userType } from "../../../models/type.model";
import Html from "./Html";
import { useHistory, useParams } from "react-router-dom";
import environment from "../../../environment";
import { toast } from "react-toastify";
import addressModel from "../../../models/address.model";
import moment from "moment";
import datepipeModel from "../../../models/datepipemodel";

const AddEditLoad2 = () => {
  const { role, id, board_id } = useParams();

  const [images, setImages] = useState({ image: "", logo: "" });
  const defaultvalue = userType;
  const Permission = JSON.parse(localStorage.getItem("permission"));

  const [form, setform] = useState({
    customer_name: "",
    total_weight: null,
    // total_distance: null,
    load_start_date: "",
    load_end_date: "",
    // total_volume: null,
    // total_pallets: null,
    // total_pieces: null,
    auction_type: "",
    origin_location_street: "",
    origin_location_city: "",
    origin_location_state: "",
    origin_location_country: "",
    origin_location_postal_code: "",
    destination_location_street: "",
    destination_location_city: "",
    destination_location_state: "",
    destination_location_country: "",
    destination_location_postal_code: "",
    board_id: "",
    stops: [],
    arriveStops: []
  });

  const [eyes, setEyes] = useState({ password: false, confirmPassword: false });
  const [submitted, setSubmitted] = useState(false);
  const history = useHistory();
  const [roles, setRoles] = useState([]);
  const [emailLoader, setEmailLoader] = useState(false);
  const [emailErr, setEmailErr] = useState("");
  const [Stops, SetStops] = useState([{ address: "", stop_city: "", stop_state: "" }]);
  const [arriveStops, ArriveSetStops] = useState([{ arrive_stop: "", arrive_DayOffset: "" }]);
  const [ChangeStatus, setChangeStatus] = useState("");
  const [detail, setDetail] = useState();
  const user = useSelector((state) => state.user);
  const SearchParam = new URLSearchParams(window.location.search);



  useEffect(() => {
    let key = SearchParam.get("board_id");

    setform({ ...form, board_id: key });


    // if (!Permission?.load_add || !Permission?.load_edit) {
    //   history.push("/dashboard");
    // }
  }, []);

  const getError = (key) => {
    // return methodModel.getError(key, form, formValidation)
  };

  const handleSubmit = (e) => {

    e.preventDefault();
    setSubmitted(true);
    if (!form?.load_start_date || !form?.load_end_date || (form?.board_id == environment?.contractId && (!form?.departure_time || !form?.arriveTime))) {
      return
    }

    let method = "post";
    let url = "load";
    let value = {};
    if (form?.board_id == environment.rfpsId) {
      value = {
        customer_name: form?.customer_name,
        board_id: form?.board_id,
        notes: form?.notes,
        comments: form?.comments,
        total_weight: form?.total_weight,
        load_start_date: moment(form?.load_start_date).format(
          "YYYY-MM-DDTHH:mm"
        ) + ":00.000Z",
        load_end_date: moment(form?.load_end_date)
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z",
        // load_start_date:moment(form?.load_start_date).format("YYYY-MM-DDTHH:mm")+":00.000Z",
        // load_end_date: form?.load_end_date,

        origin_location_street: form?.origin_location_street,
        origin_location_city: form?.origin_location_city,
        origin_location_state: form?.origin_location_state,
        origin_location_country: form?.origin_location_country,
        origin_location_postal_code: form?.origin_location_postal_code,

        destination_location_city: form?.destination_location_city,
        destination_location_state: form?.destination_location_state,
        destination_location_country: form?.destination_location_country,
        destination_location_postal_code:
          form?.destination_location_postal_code,
        destination_location_street: form?.destination_location_street,
        // load_id: parseInt(form?.load_id),

        est_volume: form?.est_volume,
        capacity: form?.capacity,
        dispatch_days: form?.dispatch_days,
        lane_id: form?.lane_id,
        lane_duration: form?.lane_duration,
        all_in_rate: form?.all_in_rate,
        frequency: form?.frequency,
        origin_address: form?.origin_address,
        destination_address: form?.destination_address,
        stops: form?.stops,
      };
    }
    if (!(form?.board_id == environment.rfpsId)) {
      value = {
        total_distance: form?.total_distance,
        // pu_date_time: moment(form?.pu_date_time).format("YYYY-MM-DDTHH:mm")+":00.000Z",
        load_start_date: moment(form?.load_start_date).format("YYYY-MM-DDTHH:mm") + ":00.000Z",
        load_end_date: moment(form?.load_end_date)
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z",
        board_id: form?.board_id,
        notes: form?.notes,
        pu_rate: form?.pu_rate,
        bid_rate: form?.bid_rate,
        origin_location_street: form?.origin_location_street,
        origin_location_city: form?.origin_location_city,
        origin_location_state: form?.origin_location_state,
        origin_location_country: form?.origin_location_country,
        origin_location_postal_code: form?.origin_location_postal_code,

        destination_location_city: form?.destination_location_city,
        destination_location_state: form?.destination_location_state,
        destination_location_country: form?.destination_location_country,
        destination_location_postal_code: form?.destination_location_postal_code,
        destination_location_street: form?.destination_location_street,
        load_id: form?.load_id,
        total_distance: form?.total_distance,

        origin_address: form?.origin_address,
        destination_address: form?.destination_address,
        stops: form?.stops,
      };
    }
    if (form?.board_id == environment?.contractId) {
      value = {
        customer_name: form?.customer_name,
        board_id: form?.board_id,
        notes: form?.notes,
        load_id: form?.load_id,
        load_start_date: moment(form?.load_start_date).format(
          "YYYY-MM-DDTHH:mm"
        ) + ":00.000Z",
        // load_end_date: moment(form?.load_end_date).format(
        //   "YYYY-MM-DDTHH:mm"
        // ) + ":00.000Z",
        //  NEw Line According to Backend Logic
        load_end_date: moment(form?.load_end_date)
          .endOf("day")
          .format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z",

        // load_start_date:moment(form?.load_start_date).format("YYYY-MM-DDTHH:mm")+":00.000Z",
        // load_end_date: form?.load_end_date,
        departure_time: moment(form?.departure_time).format(
          "YYYY-MM-DDTHH:mm"
        ) + ":00.000Z",
        arriveTime: moment(form?.arriveTime).format(
          "YYYY-MM-DDTHH:mm"
        ) + ":00.000Z",

        type: form?.type,
        origin_location_street: form?.origin_location_street,
        origin_location_city: form?.origin_location_city,
        origin_location_state: form?.origin_location_state,
        origin_location_country: form?.origin_location_country,
        origin_location_postal_code: form?.origin_location_postal_code,
        total_distance: form?.total_distance,
        destination_location_city: form?.destination_location_city,
        destination_location_state: form?.destination_location_state,
        destination_location_country: form?.destination_location_country,
        destination_location_postal_code: form?.destination_location_postal_code,
        destination_location_street: form?.destination_location_street,
        frequency: form?.frequency,
        bid_rate: form?.bid_rate,
        pu_rate: form?.pu_rate,
        origin_address: form?.origin_address,
        destination_address: form?.destination_address,
        stops: form?.stops,
        lineTreavel: form?.lineTreavel,
        // origin_nass: form?.origin_nass,
        origin_name: form?.origin_name,
        // destination_nass: form?.destination_nass,
        destination_name: form?.destination_name,
        frequency_description: form?.frequency_description,
        frequency: form?.frequency,
        perpetual_frequency: form?.perpetual_frequency,
        avg_mph: form?.avg_mph,
        miles: form?.miles,
        travel_time: form?.travel_time,
        service_type: form?.service_type,
        annual_miles: form?.annual_miles,
        arriveStops: arriveStops,
        arrive_destination: form?.arrive_destination,
        arrive_destinationDayOffset: form?.arrive_destinationDayOffset,
        arriveStops: form?.arriveStops

      };
    }
    if (id) {
      method = "put";
      url = "load";
      value = {
        ...value,
        id: form?.id
      }

    } else {
      delete value.id;
    }

    if (form.dialCode != "") {
      loader(true);
      ApiClient.allApi(url, value, method).then((res) => {
        if (res.success) {
          // toast.success(res.message);
          let url = "/loads";
          if (role) url = "/users/" + role;
          history.push(url);
        }
        loader(false);
      });
    }
  };

  const imageResult = (e, key) => {
    images[key] = e.value;
    setImages(images);
  };
  const addressResult = async (e) => {

    let address = {};
    if (e.place) {
      address = await addressModel.getAddress(e.place);
    }

    setform({
      ...form,
      origin_address: e.value,
      origin_location_country: address.country || "",
      origin_location_city: address.city || "",
      origin_location_state: address.state || "",
      origin_location_postal_code: address.zipcode || "",
      origin_lat: `${address.lat}` || "",
      origin_lng: `${address.lng}` || "",
    });
  };

  const back = () => {
    history.goBack();
  };



  const emailCheck = (email) => {
    let isValid = methodModel.emailvalidation(email);
    if (isValid) {
      setEmailLoader(true);
      ApiClient.get("check/Email", { email: email }).then((res) => {
        if (!res.success) {
          if (detail?.email != email) {
            setEmailErr(res.error.message);
          }
        } else {
          setEmailErr("");
        }
        setEmailLoader(false);
      });
    }
  };
  const StartdateTime = (load_start_date) => { return load_start_date?.split("T").join().split(".")?.[0] }

  const GetLoadDetails = () => {
    ApiClient.get("load", { id }).then((res) => {
      const Startdate = new Date(`${moment(StartdateTime(res?.data?.load_start_date)).format(
        'DD-MMM-YYYY'
      )},
      ${datepipeModel.isotime(
        res?.data?.load_start_date
      )}`)

      const Enddate = new Date(`${moment(StartdateTime(res?.data?.load_end_date)).format(
        'DD-MMM-YYYY'
      )},
      ${datepipeModel.isotime(
        res?.data?.load_end_date
      )}`)

      // const LoadEndDate = Enddate.toString();
      const date = new Date(`${moment(StartdateTime(res?.data?.departure_time)).format(
        'DD-MMM-YYYY'
      )},
      ${datepipeModel.isotime(
        res?.data?.departure_time
      )}`)

      // const LoadDepartureDate = date.toString();

      const arriveDate = new Date(`${moment(StartdateTime(res?.data?.arriveTime)).format(
        'DD-MMM-YYYY'
      )},
      ${datepipeModel.isotime(
        res?.data?.arriveTime
      )}`)

      if (res.success) {
        setform({
          ...res?.data,
          load_start_date: Startdate,
          load_end_date: Enddate,
          departure_time: date,
          arriveTime: arriveDate,
          board_id: res?.data?.board_id?.id
        });
        let stops = res?.data?.stops || [];
        // if (!stops.length) stops = [{ address: "" }];
        let arriveStops = res?.data?.arriveStops || [];
        // if (!arriveStops.length) stops = [{ address: "" }];
        SetStops(stops);
        ArriveSetStops(arriveStops)
      }
    });
  };
  useEffect(() => {
    setSubmitted(false);
    // setState()
    if (id) {
      GetLoadDetails();
    }

  }, [id]);

  return (
    <>
      <Html
        form={form}
        detail={detail}
        emailCheck={emailCheck}
        emailLoader={emailLoader}
        emailErr={emailErr}
        ChangeStatu={ChangeStatus}
        back={back}
        setEyes={setEyes}
        eyes={eyes}
        role={role}
        setform={setform}
        roles={roles}
        submitted={submitted}
        images={images}
        addressResult={addressResult}
        handleSubmit={handleSubmit}
        imageResult={imageResult}
        getError={getError}
        Stops={Stops}
        SetStops={SetStops}
        arriveStops={arriveStops}
        ArriveSetStops={ArriveSetStops}
      // DestinationAddress={DestinationAddress}
      />
    </>
  );
};

export default AddEditLoad2;
